import { AlertProps } from '@a-ui/react';
import React from 'react';
import { Action, Types } from './actions';

export interface MessageState {
  type?: AlertProps['theme'];
  message?: string | React.ReactNode;
  location: string | undefined;
  seen: boolean;
}

export const initialState: MessageState = {
  seen: false,
  location: undefined,
};

export const messageReducer = (state: MessageState, action: Action): MessageState => {
  switch (action.type) {
    case Types.SET:
      return {
        ...state,
        ...action.payload,
        seen: false,
      };

    case Types.UNSET:
      return initialState;

    case Types.SET_SEEN:
      return {
        ...state,
        seen: true,
      };

    default:
      return state;
  }
};
